import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import Link from 'src/components/Link';

import getConfig from 'next/config';
import { getCustomerCareEmail } from './platformUtils';

const { publicRuntimeConfig } = getConfig();

export const getTranslatedData = (
  data: { [key: string]: any },
  key: string,
  locale = '',
  i18nKey?: string,
) => {
  // in case there is used inside an useEffect we need to provide the locale
  if (!locale) {
    locale = useIntl().locale;
  }

  const translationKey = i18nKey ?? key;

  const current = data?.i18nList?.filter((tran) => tran.language === locale);

  if (current?.length) return current[0][translationKey];

  return data?.[key];
};

export const customFormatMessage = (text: string, values?: any) => {
  return (
    <FormattedMessage
      id={text}
      values={{
        strong: (chunks: string) => <strong>{chunks}</strong>,
        italic: (chunks: string) => <i>{chunks}</i>,
        u: (chunks: string) => <u>{chunks}</u>,
        br: <br />,
        ul: (chunks: string) => <ul>{chunks}</ul>,
        ol: (chunks: string) => <ol>{chunks}</ol>,
        li: (chunks: string) => <li>{chunks}</li>,
        lstrong: (chunks: string) => (
          <span style={{ fontWeight: '600', cursor: 'pointer' }}>{chunks}</span>
        ),
        link_privacyPolicy: (chunks: string) => (
          <Link href="/politica-privacidad">
            <span className="termsPage__externLink">{chunks}</span>
          </Link>
        ),
        link_privacyPolicyDE: (chunks: string) => (
          <Link href="/politica-privacidad">
            <span className="termsPage__externLink-germany">{chunks}</span>
          </Link>
        ),
        link_contactUs: (chunks: string) => (
          <Link href="/contact-us">
            <span className="termsPage__externLink">{chunks}</span>
          </Link>
        ),
        link_US_MED: (chunks: string) => (
          <a
            className="termsPage__externLink"
            href={`${chunks}`}
            target="_blank"
            rel="noreferrer">
            {chunks}
          </a>
        ),
        email: (chunks: string[]) => (
          <a
            className="mail-to-link"
            href={`mailto: ${chunks}`}
            target="_blank"
            rel="noreferrer">
            {chunks}
          </a>
        ),
        emailCCText: (chunks: string[]) => (
          <a
            className="mail-to-link"
            href={`mailto: ${getCustomerCareEmail()}`}
            target="_blank"
            rel="noreferrer">
            {chunks}
          </a>
        ),
        linkGetPoints: (chunks: string[]) => (
          <Link href="/scan#faqsHowGetPoints">
            <span className="scanPage__externalLink">{chunks}</span>
          </Link>
        ),
        linkFaqs: (chunks: string) => (
          <Link href="/">
            <span className="scanPage__externalLink">{chunks}</span>
          </Link>
        ),
        linkProducts: (chunks: string) => (
          <Link href="/productos">
            <span className="scanPage__externalLink">{chunks}</span>
          </Link>
        ),
        linkTerms: (chunks: string) => (
          <a
            className="link-to-terms"
            href={`${
              publicRuntimeConfig.PLATFORM_PREFIX || ''
            }/terms-conditions`}
            target="_blank"
            rel="noreferrer">
            {chunks}
          </a>
        ),
        ...values,
      }}
    />
  );
};

export const buildRegularParagraph = (text: string): JSX.Element => {
  return <p className="regular-body">{customFormatMessage(text)}</p>;
};
